<script setup lang="ts">
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { computed, defineProps } from 'vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toast-notification'

const partnerStore = usePartnerStore()
const { searchValue, partner, creatingPartner } = storeToRefs(partnerStore)
const props = defineProps(['params'])
const siretCreate = computed(() => {
  return props.params?.data?.siret || searchValue.value || ''
})
const router = useRouter()
const $toast = useToast()

async function handleClick() {
  try {
    await partnerStore.createBySiret(siretCreate.value)
    if (partner.value) {
      await router.push(`/partner/${partner?.value.id}`)
      $toast.success('Société ajoutée')
    } else {
      $toast.error("La société n'a pas pu être créée")
    }
  } catch (e) {
    console.error(e)
    let errorMessage = "Une erreur est survenue"
    if (e instanceof Error) {
      errorMessage = e.message
      const errorWithBody = e as Error & { response?: Response }
      if (errorWithBody.response) {
        try {
          const body = await errorWithBody.response.json()
          if (body && body.message) {
            errorMessage = body.message
          }
        } catch (jsonError) {
          console.error("Impossible de parser le corps de l'erreur", jsonError)
        }
      }
    }
    $toast.error(`Erreur lors de la création : ${errorMessage}`)
  }
}
</script>

<template>
  <ButtonDaisy text="Ajouter la société" @click="handleClick" :loader="creatingPartner" />
</template>
